import { render } from "./AuthenticationCard.vue?vue&type=template&id=ca252b60"
const script = {}
script.render = render

export default script